import JsonDownloadHandler from './JsonDownloadHandler';
import { generatePdf } from './PdfDownloadHandler';
import { fetchSerializedAasEnvironment } from '../../services/DppManagerService';
import Config from '../../config/Config';
import { sortSubmodels } from '../Utils';

const DownloadHandler = async ({ data, aasId, aasIdBase64, locale, setError, setSuccess }) => {
  setError(null);

  if (!data?.format) {
    setError('Invalid download format selected.');
    return;
  }

  try {
    const env = await fetchSerializedAasEnvironment(aasId);

    env.submodels = sortSubmodels(env.submodels, Config.dpp.submodels.orderByIdShort);

    if (data.format === 'json') {
      await JsonDownloadHandler({ env, aasIdBase64, setError, setSuccess });
    } else if (data.format === 'pdf') {
      await generatePdf(env, aasIdBase64, locale, setError, setSuccess);
    } else {
      setError('Unsupported format: ' + data.format);
    }
  } catch (err) {
    console.error(err);
    setError('Failed to fetch AAS environment.');
  }
};

export default DownloadHandler;